// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"40e9b0c6","544":"87b59637","629":"8c3458f9","674":"2b9cbbee","805":"f06f9c1b","899":"f4ed00f9"}[chunkId] + ".chunk.js";
};